/**
 * Supabase Client Configuration
 *
 * Generic Supabase client setup for authentication and API calls
 */

import { createClient } from '@supabase/supabase-js'

// Environment variables - you'll need to add these to your .env file
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables')
}

// Create Supabase client
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true
  }
})

// Helper function to sign out
export const signOut = () => {
  return supabase.auth.signOut()
}

// Convert Supabase user to our User interface
export const convertSupabaseUser = (supabaseUser) => {
  return {
    id: supabaseUser.id,
    name:
      supabaseUser.user_metadata?.full_name ||
      supabaseUser.user_metadata?.name ||
      supabaseUser.email?.split('@')[0] ||
      'User',
    email: supabaseUser.email || '',
    avatar_url: supabaseUser.user_metadata?.avatar_url || supabaseUser.user_metadata?.picture,
    provider: supabaseUser.app_metadata?.provider || 'unknown'
  }
}

// Sign in with Azure (Microsoft)
export const signInWithAzure = () => {
  return supabase.auth.signInWithOAuth({
    provider: 'azure',
    options: {
      redirectTo: `${window.location.origin}`,
      scopes: 'openid profile email'
    }
  })
}
